"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var operators_1 = require("rxjs/operators");
var LockUserAction = /** @class */ (function (_super) {
    __extends(LockUserAction, _super);
    function LockUserAction(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleUserLockStatus = function () {
            if (_this.state.user) {
                var editedUser = _this.state.user;
                editedUser.enabled = !_this.state.user.enabled;
                _this.props.showLoader();
                _this.supportPortalService.updateIdentityUser(_this.props.customerId, editedUser).pipe((0, operators_1.finalize)(function () { return _this.props.hideLoader(); })).subscribe();
                _this.supportPortalService.logAgentActivity(_this.props.customerId, { "action": (_this.state.user.enabled) ? "Unlock User" : "Lock User", "customer": "Account" }).subscribe();
                _this.setState({
                    user: editedUser
                });
            }
        };
        _this.state = {
            user: null
        };
        return _this;
    }
    LockUserAction.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.customerId) {
            this.supportPortalService
                .getIdentityUser(this.props.customerId)
                .pipe().subscribe(function (user) {
                _this.setState({ user: user });
            });
        }
    };
    LockUserAction.prototype.render = function () {
        if (this.state.user) {
            return ((0, jsx_runtime_1.jsx)("a", { className: "d-block text-primary on-hover-underline", onClick: this.toggleUserLockStatus, children: (this.state.user.enabled) ? "Lock User" : "Unlock User" }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], LockUserAction.prototype, "supportPortalService", void 0);
    LockUserAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead", "CSR"),
        __metadata("design:paramtypes", [Object])
    ], LockUserAction);
    return LockUserAction;
}(React.Component));
exports.default = LockUserAction;
//# sourceMappingURL=LockUserAction.js.map